module.exports = __webpack_public_path__ + "assets/9aa1456c5622a0ece0e2f77cac366d1c.png";